export default class PlagiarismBundle {
  private readonly _amount: number;
  private readonly _used: number;
  constructor({amount, used}) {
    this._amount = amount;
    this._used = used;
  }

  get amount(): number {
    return this._amount;
  }

  get used(): number {
    return this._used;
  }

  get isBundleActive() : boolean {
    return this._used < this._amount;
  }

  get getRemainingChecks() : number {
    return this._amount - this._used;
  }
}
